import { EnvironmentProviders, isDevMode, makeEnvironmentProviders } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { AVAILABLE_LANGS } from './languages';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';
import { provideTransloco } from '@jsverse/transloco';
import { scopeTranslocoInterceptor, TranslocoHttpLoader } from './transloco.loader';

export function provideRootTransloco(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideHttpClient(),
    provideTransloco({
      config: {
        availableLangs: AVAILABLE_LANGS,
        defaultLang: AVAILABLE_LANGS[0].id,
        fallbackLang: AVAILABLE_LANGS[0].id,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        flatten: {
          aot: !isDevMode(),
        },
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoMessageformat(),
    scopeTranslocoInterceptor,
  ]);
}
